export default {
  name: 'allCommodity',
  path: 'allCommodity',
  component: () =>
    import(/* webpackChunkName: "ManualSettings" */ './index.vue')
}
